import { styled } from "goober";
import type { Ref } from "react";
import type { NetworkDestination } from "../../../../db/schema";
import { Button } from "../../Button";
import { Input } from "../../Input";
import { SegmentedControl } from "../../SegmentedControl";

type DestinationType = NetworkDestination["type"];

const Row = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export function DestinationInput({
  type,
  onTypeChange,
  value,
  onValueChange,
  onAdd,
  inputRef,
}: {
  type: DestinationType;
  onTypeChange: (type: DestinationType) => void;
  value: string;
  onValueChange: (value: string) => void;
  onAdd: () => void;
  inputRef?: Ref<HTMLInputElement>;
}) {
  return (
    <Row>
      <SegmentedControl
        options={["Hostname", "CIDR"] as const}
        tabWidth={80}
        value={type === "cidr" ? "CIDR" : "Hostname"}
        onChange={(v) => onTypeChange(v === "CIDR" ? "cidr" : "hostnameGlob")}
      />
      <Input
        ref={inputRef}
        placeholder={
          type === "hostnameGlob" ? "*.internal.acme.com" : "10.0.0.0/16"
        }
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onAdd();
          }
        }}
        style={{ flex: 1, minWidth: 0 }}
      />
      <Button
        size="l"
        variant="subtle"
        icon="plus"
        onClick={onAdd}
        disabled={!value.trim()}
      >
        Add
      </Button>
    </Row>
  );
}
